import {Group} from '@cypro/engine/schema'
import {Account as BetterAuthAccount, Session as BetterAuthSession} from 'better-auth'
import {adminClient, jwtClient, multiSessionClient, usernameClient} from 'better-auth/client/plugins'
import {createAuthClient} from 'better-auth/react'
export interface Session extends BetterAuthSession {
  access: {
    locationId: string
    sectionId: string | null
    wardId: string | null
  }[]
  account: Account
  groups: Group[]
  impersonatedBy?: string
}

export interface Account extends BetterAuthAccount {
  passwordSetupCompletedAt?: string
}

export const authClient = createAuthClient({
  baseURL: location.origin,
  basePath: '/api/auth',
  plugins: [usernameClient(), adminClient(), jwtClient(), multiSessionClient()],
})
